export enum ExtraService {
  PROFESSIONAL_PHOTOSHOOTING,
  LEGAL_SERVICES,
  PROPERTY_SHOWING,
  ENGINEERING_SERVICES,
}
